import axios from "axios";


// =====================================================
// AXIOS INSTANCE
// =====================================================

const api = axios.create({

    baseURL: process.env.REACT_APP_API_URL || "/api",

    timeout: 30000,

    headers: {
        "Content-Type": "application/json"
    }

});


// =====================================================
// REQUEST INTERCEPTOR
// =====================================================
// Automatically attach JWT token to every request
// =====================================================

api.interceptors.request.use(

    (config) => {

        const token =
            localStorage.getItem(
                "erp_token"
            );

        if (token) {

            config.headers.Authorization =
                `Bearer ${token}`;

        }

        return config;

    },

    (error) => {

        return Promise.reject(
            error
        );

    }

);


// =====================================================
// RESPONSE INTERCEPTOR
// =====================================================
// If token is expired/invalid, logout automatically
// =====================================================

api.interceptors.response.use(

    (response) =>  response,

    

    (error) => {

        if (
            error?.response?.status === 401
        ) {

            // Remove saved login information
            localStorage.removeItem(
                "erp_token"
            );
            localStorage.removeItem("token"
            );

            localStorage.removeItem(
                "erp_user"
            );
            localStorage.removeItem("user");

            // Redirect to login page
            if (
                window.location.pathname !==
                "/login"
            ) {

                window.location.replace("/login");

            }

        }

        return Promise.reject(
            error
        );

    }

);


// =====================================================
// CHAMBERS
// =====================================================

// Get all chambers
export const getChambers = () => {

    return api.get(
        "/chambers"
    );

};


// Get single chamber
export const getChamberById = (id) => {

    return api.get(
        `/chambers/${id}`
    );

};


// =====================================================
// GRN / GOODS RECEIVED
// =====================================================

// Create new GRN
export const createGRN = (data) => {

    return api.post(
        "/grns",
        data
    );

};


// Get all GRNs
export const getGRNs = () => {

    return api.get(
        "/grns"
    );

};


// Get single GRN
export const getGRNById = (id) => {

    return api.get(
        `/grns/${id}`
    );

};


// Update existing GRN
export const updateGRN = (
    id,
    data
) => {

    return api.put(
        `/grns/${id}`,
        data
    );

};


// Delete GRN
export const deleteGRN = (id) => {

    return api.delete(
        `/grns/${id}`
    );

};


// =====================================================
// INVENTORY
// =====================================================

// Get complete inventory
export const getInventory = () => {

    return api.get(
        "/inventory"
    );

};


// Get single inventory record
export const getInventoryById = (id) => {

    return api.get(
        `/inventory/${id}`
    );

};


// Get inventory by chamber
export const getInventoryByChamber = (
    chamberId
) => {

    return api.get(
        `/inventory/chamber/${chamberId}`
    );

};


// =====================================================
// DELIVERY / DELIVERY CHALLAN
// =====================================================

// Create delivery challan
export const createDelivery = (
    data
) => {

    return api.post(
        "/deliveries",
        data
    );

};


// Get all delivery challans
export const getDeliveries = () => {

    return api.get(
        "/deliveries"
    );

};


// Get single delivery challan
export const getDeliveryById = (
    id
) => {

    return api.get(
        `/deliveries/${id}`
    );

};


// Update existing delivery challan
export const updateDelivery = (
    id,
    data
) => {

    return api.put(
        `/deliveries/${id}`,
        data
    );

};


// Delete delivery challan
export const deleteDelivery = (
    id
) => {

    return api.delete(
        `/deliveries/${id}`
    );

};


// =====================================================
// DASHBOARD
// =====================================================

// Get live dashboard data
export const getDashboard = () => {

    return api.get(
        "/dashboard"
    );

};


// =====================================================
// DATABASE TEST
// =====================================================

// Test MySQL connection
export const testDatabase = () => {

    return api.get(
        "/test-db"
    );

};


// =====================================================
// DEFAULT EXPORT
// =====================================================

export default api;
